import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import { connectSearchBox } from 'react-instantsearch-dom'
import { CategoriesContext } from '../../contexts/CategoriesContext'
import useDebounce from '../../hooks/helper/useDebounce'
import { tagSearch } from '../../lib/events'
import { BsSearch } from 'react-icons/bs'

const SearchBox = ({ currentRefinement, refine, searchText, setSearchText }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const debouncedSearchTerm = useDebounce(searchTerm, 1000);
    const router = useRouter();
    const { isRerender } = useContext(CategoriesContext);

    useEffect(() => {
        if (debouncedSearchTerm) {
            refine(searchTerm);
            setSearchText(searchTerm);
            tagSearch(searchTerm);
        } else {
            refine('');
            setSearchText('');
        }
    }, [debouncedSearchTerm])

    useEffect(() => {
        if (searchText == "") {
            refine('');
            setSearchText('');
            setSearchTerm('');
        }
    }, [searchText])

    const startSearching = async () => {
        document.body.style.overflow = "auto";

    }
    useEffect(() => {
        setSearchTerm('');
        refine('');
        setSearchText('');
    }, [isRerender])


    return (
        <>
            <form onSubmit={(e) => { e.preventDefault(); }} noValidate role="search" className="position-relative d-flex align-items-center ais-SearchBox-form ">
                <BsSearch size={18} className="position-absolute" style={{ top: '50%', transform: 'translate(100%,-50%)' }} />
                <input
                    type="search" placeholder="Search Anything..." autoComplete="on"
                    value={searchTerm}
                    className="form-control h-100 w-100  px-3 ps-5 py-3"
                    onChange={e => { setSearchTerm(e.target.value) }}
                    onKeyPress={event => {
                        startSearching();
                    }}
                />
            </form>
        </>
    )
}

const DebouncedSearchBoxResource = connectSearchBox(SearchBox)

export default DebouncedSearchBoxResource